import * as http from "./base";

export async function login(data) {
  return await http.post(`/authentication/auth/login`, data);
}

export async function signUp(data) {
  return await http.post(`/account-create`, data);
}

export async function logout() {
  return await http.get(`/authentication/auth/logout`);
}

export async function requestPasswordReset(email) {
  return await http.post(`/password-reset-init`, email);
}

/**
 * Confirming resetting
 * e.g. while submitting reset form
 * @param data
 * @param token
 * @returns {Promise<void>}
 */
export async function finishPasswordReset(token, data) {
  return await http.post(`/password-reset-finish`, { token, ...data });
}

export async function sendOnboardingEmail( email) {
  return await http.post(`send-onboarding-email`, email)
}
